/**
 * Fetches /api/config once and caches it in module memory. The frontend
 * needs the Turnstile site key at runtime so we can swap test → real keys
 * without rebuilding the bundle.
 */
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cached = null;
let inflight = null;

export function useAppConfig() {
  const [config, setConfig] = useState(cached);
  useEffect(() => {
    if (cached) return undefined;
    if (!inflight) {
      inflight = axios.get(`${API}/config`).then((r) => {
        cached = r.data;
        return r.data;
      }).catch(() => ({ turnstile: { site_key: null, enabled: false } }));
    }
    let alive = true;
    inflight.then((cfg) => { if (alive) setConfig(cfg); });
    return () => { alive = false; };
  }, []);
  return config;
}
